import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const Container = styled.div<{ newDesign: boolean }>`
  padding: 1rem 0;

  ${({ newDesign }) =>
    newDesign &&
    css`
      padding: 1rem 0 2rem;
      @media (min-width: ${breakpoints.lg}) {
        padding: 1rem 0;
      }
    `}
`;

export const SelectWrapper = styled.div``;

export const Select = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

export const DeliveryList = styled.div`
  flex: 10;
  padding-right: 0.5rem;
`;

export const ChevronIconWrapper = styled.button<{ newDesign: boolean }>`
  cursor: pointer;
  width: 1rem;
  border: none;
  background-color: ${theme.color.background.primary};
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ newDesign }) =>
    newDesign
      ? css`
          max-height: 6.5rem;
        `
      : css`
          max-height: 5.5rem;
          @media (min-width: ${breakpoints.sm}) {
            max-height: 3.1rem;
          }
          @media (min-width: ${breakpoints.md}) {
            max-height: 5.5rem;
          }
          @media (min-width: ${breakpoints.lg}) {
            max-height: 3.1rem;
          }
        `}
`;

export const FlexRow = styled.div`
  align-items: flex-start;
  justify-content: space-between;
  color: ${theme.color.text.secondary};
  display: flex;
  flex-wrap: wrap;
`;

export const FlexRowWithMargin = styled(FlexRow)<{ newDesign: boolean }>`
  &:last-child {
    margin-bottom: 0;
  }

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin-bottom: 0.75rem;
        `
      : css`
          margin-bottom: 0.625rem;
        `}
`;

export const DeliveryInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-basis: 100%;
  align-items: center;
`;

export const TopDeliveryInfo = styled(DeliveryInfo)<{ newDesign: boolean }>`
  flex-basis: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin-bottom: 1.25rem;
        `
      : css`
          margin-bottom: 0.625rem;
        `}
`;

export const DeliveryInfoWrapper = styled.div<{ newDesign: boolean }>`
  display: flex;
  width: 100%;

  ${({ newDesign }) =>
    newDesign
      ? css`
          flex-direction: column;
        `
      : css`
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 0.25rem;
        `}
`;

export interface IDeliveryTextColorProps {
  isInactive: boolean;
  newPdDesignEnabled: boolean;
}

const deliveryTextColor = css`
  color: ${(props: IDeliveryTextColorProps) =>
    props.isInactive ? theme.color.text.disabled : theme.color.text.primary};
`;

export const Name = styled.div<IDeliveryTextColorProps>`
  padding-right: 0.3125rem;
  min-width: 12.5rem;
  flex-basis: 100%;
  line-height: 1.2rem;
  ${deliveryTextColor};

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? theme.typography.labelRegular
      : css`
          font-weight: bold;
          font-size: 0.875rem;
        `}

  @media (min-width: ${breakpoints.sm}) {
    flex-basis: auto;
    line-height: 1.3rem;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-basis: 100%;
    line-height: 1.2rem;
  }

  @media (min-width: ${breakpoints.lg}) {
    flex-basis: auto;
    line-height: 1.3rem;
  }
`;

export const DeliveryDate = styled.div`
  line-height: 1.2rem;
  ${deliveryTextColor}

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? theme.typography.labelRegular400
      : css`
          font-weight: 300;
          font-size: 1rem;
        `}

  @media (min-width: ${breakpoints.sm}) {
    line-height: 1.3rem;
  }
`;

export const TimeText = styled.span`
  color: ${theme.color.text.positive};
`;

export const StyledHr = styled.hr<{ newDesign: boolean }>`
  height: 0.0625rem;
  border: none;
  background-color: ${theme.color.background.disabled};

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin: 1.25rem 0 0.75rem 0;
        `
      : css`
          margin-top: 1rem;
        `}
`;

export const DeliveryDescription = styled.div<{ newPdDesignEnabled: boolean }>`
  margin: 0.625rem 0 0.75rem 0;

  color: ${theme.color.text.secondary};

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? theme.typography.bodySmall
      : css`
          font-size: 0.875rem;
        `}
`;
